export default __webpack_public_path__ + "static/media/Ellipse 111 (5).bfe8c86f.png";